import { useEffect, useState } from 'react';
import { supabase } from '../providers/supabase/supabase';
import type { SonicRecommendation } from '../types';

export interface UseSonicRecommendationsResult {
    recommendations: SonicRecommendation | null;
    loading: boolean;
    error: string | null;
}

export const useSonicRecommendations = (artistId?: string | null): UseSonicRecommendationsResult => {
    const [recommendations, setRecommendations] = useState<SonicRecommendation | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!artistId) {
            setRecommendations(null);
            setLoading(false);
            setError(null);
            return;
        }

        const fetchRecommendations = async () => {
            try {
                setLoading(true);
                setError(null);

                console.log('🎵 Fetching recommendations for artistId:', artistId);

                const { data, error: fetchError } = await supabase
                    .from('sonic_recommendations')
                    .select('*')
                    .eq('artist_id', artistId)
                    .single();

                console.log('🎵 Supabase response:', { data, fetchError });
                console.log('🎵 Data details:', data ? 'Found recommendations data' : 'No data returned');
                console.log('🎵 Similar track 1:', data?.similar_track_1_name);

                if (fetchError) {
                    if (fetchError.code === 'PGRST116') {
                        // No recommendations found for this artist
                        setRecommendations(null);
                        setError(null);
                    } else {
                        throw fetchError;
                    }
                } else {
                    setRecommendations(data);
                }
            } catch (err) {
                console.error('Error fetching sonic recommendations:', err);
                setError(err instanceof Error ? err.message : 'Failed to fetch recommendations');
            } finally {
                setLoading(false);
            }
        };

        fetchRecommendations();
    }, [artistId]);

    return { recommendations, loading, error };
};